/**
 * Delivery company (the "Företag" fields of a device)
 *
 * The company that delivers the device and that the alarm central contacts about it. A
 * device sold by a reseller shows that reseller: its name, phone and e-mail. A device sold
 * by one of our own sellers, or with no seller, shows Securdia for the device's country.
 *
 * The seller list is the one from GET /seller/reseller, where each entry is tagged with
 * _entityType "staff" or "reseller". The API keeps the same rule for the devices it writes
 * itself (securecloud-server/utils/delivery-company.js) - change both together.
 */
import app_data from "@/constants/app";

export function securdiaDeliveryCompany(country) {
  const contactInfo = country === "no" ? app_data.contact_info_no : app_data.contact_info_se;
  return {
    name: contactInfo.company_name,
    phone: contactInfo.phone,
    email: contactInfo.email,
  };
}

// A reseller's company phone and e-mail are optional, so its contact person's stand in
function resellerDeliveryCompany(reseller) {
  return {
    name: reseller.name || "",
    phone: reseller.phone || reseller.contact_phone || "",
    email: reseller.email || reseller.contact_email || "",
  };
}

/**
 * The delivery company for a device with this seller.
 *
 * Returns null when the device has a seller that is not in the list: the list has not
 * loaded yet, or this login may not read it. The caller then keeps what the device already
 * has, so opening a device can never turn a reseller's details into Securdia's.
 *
 * @param {Array} sellers  - the list from GET /seller/reseller
 * @param {string} sellerId - the device's seller (staff or reseller id), may be empty
 * @param {string} country  - "se" or "no", decides which Securdia company is shown
 */
export function deliveryCompanyForSeller(sellers, sellerId, country) {
  const seller = (sellers || []).find((s) => String(s._id) === String(sellerId));

  if (seller && seller._entityType === "reseller") return resellerDeliveryCompany(seller);
  if (sellerId && !seller) return null;
  return securdiaDeliveryCompany(country);
}
